<template>
  <div class="page-loader">
    <div class="loader-content">
      <img src="/icons/loggoo.png" alt="Logo" class="loader-logo" />
      <v-progress-circular
        indeterminate
        size="70"
        width="5"
        :color="useVendorStore.resturant.main_color"
        class="loader-spinner"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { vendorStore } from "@/store/vendor.js";
export default {
  name: 'PageLoader',
  setup() {
    const useVendorStore = vendorStore();
    return { useVendorStore };
  },
}
</script>

<style scoped>
.page-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000000; /* Solid black or use rgba(0,0,0,0.98) */
  z-index: 99999; /* Higher than everything */
}

.loader-content {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120px;
  height: 120px;
}

.loader-logo {
  width: 50px; /* Adjust based on logo aspect ratio */
  height: auto;
  position: absolute;
  z-index: 2;
  object-fit: contain;
}

.loader-spinner {
  position: absolute;
  z-index: 1;
}
</style>
  